import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isValidDate)
    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
        _createTextVNode(_toDisplayString(_ctx.dateToUse), 1)
      ], 64))
    : _createCommentVNode("", true)
}